import { render, staticRenderFns } from "./TippaniHeader.vue?vue&type=template&id=034ab988&scoped=true&"
import script from "./TippaniHeader.vue?vue&type=script&lang=js&"
export * from "./TippaniHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034ab988",
  null
  
)

export default component.exports